import React from "react";
import {
  FaExternalLinkAlt,
  FaRegFile,
  FaRegFileAudio,
  FaRegFileExcel,
  FaRegFileImage,
  FaRegFilePdf,
  FaRegFilePowerpoint,
  FaRegFileVideo,
  FaRegFileWord,
  FaYoutube,
} from "react-icons/fa";

const AssetIcon = ({ type, style }) => {
  const defaultIcon = <FaRegFile style={{ fill: "#ffba2a", ...style }} />;
  if (typeof type != "string") return defaultIcon;
  switch (type.toLowerCase()) {
    case "youtube":
      return <FaYoutube style={{ fill: "#db3a14", ...style }} />;
    case "pdf":
      return <FaRegFilePdf style={{ fill: "#db3a14", ...style }} />;
    case "doc":
      return <FaRegFileWord style={{ fill: "#185abd", ...style }} />;
    case "xls":
      return <FaRegFileExcel style={{ fill: "#107a40", ...style }} />;
    case "ppt":
      return <FaRegFilePowerpoint style={{ fill: "#c43f1d", ...style }} />;
    case "video":
      return <FaRegFileVideo style={{ fill: "#3f238f", ...style }} />;
    case "image":
      return <FaRegFileImage style={{ fill: "#1ce382", ...style }} />;
    case "audio":
      return <FaRegFileAudio style={{ fill: "#9b4a85", ...style }} />;
    default:
      return defaultIcon;
  }
};

const AssetLink = ({ link, type, label, external = true }) => {
  return (
    <a
      className="is-size-4 is-flex is-justify-content-center is-align-items-center"
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      <AssetIcon type={type} style={{ paddingRight: "0.5rem" }} /> {label}
      {external ? <FaExternalLinkAlt style={{ paddingLeft: "0.5rem" }} /> : ""}
    </a>
  );
};

export default AssetLink;
